import api, { pageData } from "./client";

export const liquidacionesPagoApi = {
  getPending: async () => (await api.get("/liquidaciones-comisiones-pago/pendientes/")).data,
  getAll: async (params = {}) => pageData((await api.get("/liquidaciones-comisiones-pago/", { params })).data),
  create: (data) => api.post("/liquidaciones-comisiones-pago/", data),
};



